var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMktgCook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94 21.2c-.07-.73-.1-1.48-.1-2.23 0-.77.63-1.4 1.4-1.4h53c.78 0 1.41.63 1.41 1.4 0 .75-.04 1.5-.1 2.24h4.53a1.4 1.4 0 11.01 2.8h-4.97C58.6 35.92 47.28 44.95 33.74 44.95 20.21 44.96 8.9 35.93 6.37 24H1.4A1.4 1.4 0 010 22.6c0-.77.63-1.4 1.4-1.4h4.54zm34.63-6.82a1.4 1.4 0 01-1.4-1.4V5.45a1.4 1.4 0 112.81 0v7.53c0 .77-.63 1.4-1.4 1.4zm-6.83 0a1.4 1.4 0 01-1.4-1.4V1.72a1.4 1.4 0 112.81 0v11.26c0 .77-.63 1.4-1.4 1.4zm-6.83 0a1.4 1.4 0 01-1.4-1.4V5.45a1.4 1.4 0 112.81 0v7.53c0 .77-.63 1.4-1.4 1.4zM58.47 52.8H9.02a1.4 1.4 0 010-2.8h49.45a1.4 1.4 0 110 2.8zM8.7 20.36c.78 12.15 11.72 21.8 25.04 21.8 13.33 0 24.27-9.66 25.05-21.8H8.69z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-mktg--cook-a0642e40d22548d5ea6de9d2e636019d.svg";
export { SvgIconMktgCook as Component };